import React from 'react';
import { useState, useEffect } from "react";
import { BsInput } from '@MyLib/Bootstrap/BsForm';

/*
pattern = /\d{3}-\d{4}/g;

data = "私の郵便番号は、123-4567です。";
if (data.match(pattern)) {
	console.log(data,"は、マッチしました。");
} else {
	console.log(data,"は、マッチしません。");
}

data = "誰かの郵便番号は、1234-567です。";
if (data.match(pattern)) {
	console.log(data,"は、マッチしました。");
} else {
	console.log(data,"は、マッチしません。");
}
*/

const HighlightedText = ({ text, regex }) => {
	// キーワードで分割（括弧で囲むことで、キーワード自体も配列に残す）
	const parts = text.split(new RegExp(`(${regex})`, 'g'));

	return (
		<span>
			{parts.map((part, i) => {
				const isPostCode = new RegExp(`${regex}`).test(part);
				return isPostCode ? (
				<b key={i} style={{ color: 'red' }}>{part}</b> // マッチした所
				) : (
					part // マッチしなかった所
				);
			})}
		</span>
	);
};

export const RegexApp = () =>
{
	//const [regex, setRegex] = useState("JavaScript");
	//const [text, setText] = useState("Node.jsは非常に高速なJavaScript環境です。JavaScriptを学びましょう。");
	const [regex, setRegex] = useState("\\d{3}-\\d{4}");
	const [text, setText] = useState("私の郵便番号は、123-4567です。");
	//const [regex, setRegex] = useState("");
	//const [text, setText] = useState("");

	useEffect(() => {
		if (regex != "" && text != "") {
			const parts = text.split(new RegExp(`(${regex})`, 'g'));
			console.log(parts);
		}
	}, [regex, text]);

	return (
		<div className="container">
			<h2>正規表現 簡易チェッカー</h2>
			<div className="mb-4">
				<div className="fw-bold">正規表現</div>
				<BsInput value={regex} setValue={setRegex} />
			</div>
			<div className="mb-4">
				<div className="fw-bold">チェックする文字列</div>
				<BsInput value={text} setValue={setText} />
			</div>
			<div className="mb-4">
				<div className="fw-bold">検索結果</div>
				<HighlightedText text={text} regex={regex} />
			</div>
			{/*
			<div className="mb-4">
				<div className="fw-bold">置換する文字列</div>
				<BsInput/>
			</div>
			<div className="mb-4">
				<div className="fw-bold">置換結果</div>
				<div></div>
			</div>
			*/}
		</div>
	);
};
